import script from "./qbankInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./qbankInfo.vue?vue&type=script&setup=true&lang=js"

import "./qbankInfo.vue?vue&type=style&index=0&id=c92c3d1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c92c3d1c"]])

export default __exports__